/* Package JSON Import will be here */
import React from "react";
import { Form, Input, Button, Row, Col } from "antd";
import { getTranslate } from "react-localize-redux";
import { useSelector, useDispatch } from "react-redux";
/* Package JSON Import will be here */

/* Project Import will be here */
import { changeDefaultPassword } from "reducers/session";
import { INewLoginChangePasswordParams } from "models/sessionModels";
import { ButtonSpinner } from "components/Spinner";
import { errorToast } from 'utilities/utils';
/* Project Import will be here */

const ChangePasswordForm = () => {
    const { translate, session } = useSelector((state) => ({
        translate: getTranslate(state.locale),
        session: state.session
    }));

    const dispatch = useDispatch();

    const onSubmitChangePassword = (values) => {
        const enteredNewPassword = values.newPassword.trim();
        const enteredConfirmationPassword = values.confirmationPassword.trim();

        if (enteredNewPassword !== "" && enteredConfirmationPassword !== "") {
            const requestParam: INewLoginChangePasswordParams = {
                NewPassword: enteredNewPassword,
                ConfirmPassword: enteredConfirmationPassword
            };

            dispatch(changeDefaultPassword(requestParam))
        }
        else {
            errorToast({ content: translate("common.error.password") });
        }
    }

    const getFormInitialValues = () => {
        return { userName: session.loginId };
    };

    return (
        <Form
            name="newLoginChangePasswordForm"
            className="signIn-page"
            onFinish={onSubmitChangePassword}
            initialValues={getFormInitialValues()}>
            <Row>
                <Col span={24} md={24} className="font-12 p-1 font-bold">
                    {translate("session.common.username")}
                </Col>

                <Col span={24} md={24}>
                    <Form.Item
                        name="userName"
                        rules={[{ required: true, message: translate("common.error.userName") }]}>
                        <Input
                            size="large"
                            maxLength={50}
                            disabled
                            placeholder={translate("session.signIn.placeholder.enterUnameOrMNo")}
                            className="sign-in-input-height round-radius"
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={24} md={24} className="font-12 p-1 font-bold">
                    {translate("session.changePassword.title")}
                </Col>

                <Col span={24} md={24}>
                    <Form.Item
                        name="newPassword"
                        hasFeedback
                        rules={[{ required: true, message: translate("common.error.newPassword") }]}>
                        <Input.Password
                            size="large"
                            maxLength={50}
                            placeholder={translate("session.common.newPassword")}
                            className="sign-in-input-height round-radius"

                        />
                    </Form.Item>
                </Col>
                <Col span={24} md={24}>
                    <Form.Item
                        name="confirmationPassword"
                        dependencies={['newPassword']}
                        hasFeedback
                        rules={[
                            { required: true, message: translate("common.error.confirmationPassword") },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('newPassword') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error(translate("common.alerts.error.E031")));
                                },
                            })
                        ]}>
                        <Input.Password
                            size="large"
                            maxLength={50}
                            placeholder={translate("session.common.confirmationPassword")}
                            className="sign-in-input-height round-radius"
                        />
                    </Form.Item>
                </Col>
            </Row>

            <Row>
                <Col span={24} className="text-center">
                    <Form.Item>
                        <Button
                            disabled={session.isLoading}
                            shape="round"
                            className="sign-in-btn-width mb-1"
                            type="primary"
                            htmlType="submit"
                        >
                            {translate("common.buttons.submit")}
                            {(session.isLoading) && <ButtonSpinner />}
                        </Button>
                    </Form.Item>
                </Col>
            </Row>
        </Form >
    );
};

export default ChangePasswordForm;